import { useEffect,useState, useContext } from "react";
import { makeStyles } from "@mui/styles";
import {
  Alert, AlertTitle,
  Button,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Tooltip,
  Typography,
  Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import moment from "moment";
// import { DatePicker, LocalizationProvider } from "@mui/lab";
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { PlanningState } from './index';
import { useLocalStorage } from "../../componentUtils/LocalStorage";
import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import {getAlertMessageData} from "../../utils/GetAlertMessagesData"
import { PickersDay, PickersDayProps, pickersDayClasses } from '@mui/x-date-pickers/PickersDay';
import InfoIcon from '@mui/icons-material/Info';
import { DisplayRoleContext } from "../../Context_api";

interface Inputs {
  setRoutesSelected:any;
  routeEvent:any;
  salesOrgEvent:any
  setRouteEvent:any;
  setSalesOrgEvent:any;
  setAlertClearRoute:any;
  routesSelected:any;
  data: PlanningState;
  onSelectionChange: any;
  onDateChange: any;
  tomorrow: Date;
  datePickerData:any[]
}

interface HeaderState {
  deliveringPlant: string,
  route: string,
  routes: any,
}

enum SaveActionAlertType {
  DATE='DATE',
  ROUTE='ROUTE'
}

export const tableHeightReducePx = 75;
const AlertSuccess = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert  elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Header(props: Inputs) {
  const {isDisplayOnlyRole}:any = useContext(DisplayRoleContext);
  const [defaultSalesOffice,] = useLocalStorage("SETTINGS.defaultSalesOffice", '');
  const [saveDraftAlert, setSaveDraftAlert] = useState<any>({});
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", '4100');
  const useStyles = makeStyles((theme: Theme) => ({
    cont: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    grid: {
      marginLeft: theme.spacing(2),
    },
    save: {
      textAlign: "center",
      justify: "center",
    },
  }));

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<{title:string,message:string}|undefined>(undefined);
  const [selectedDate, setSelectedDate] = useState(props.tomorrow);
  const [state, setState] = useState<HeaderState>({
    deliveringPlant: defaultSalesOffice,
    route: "",
    routes: [],
  });
  const [modifiedDate,setModifiedDate]=useState(props.tomorrow);

  const formatDateLabel = (date: MaterialUiPickersDate, invalidLabel: string) => {
    if (isPastDate(date)) {
      return "Cannot plan for past days";
    }
    const inpDate = moment(date);
    return date && inpDate.isValid()
      ? inpDate.format("dddd, MMMM Do YYYY")
      : invalidLabel;
  };

  const isPastDate = (date: MaterialUiPickersDate): boolean => {
    const inpDate = moment(date);
    if (inpDate.isBefore(moment(new Date()).add(-7, "months"))) {
      return true;
    } else {
      return false;
    }
  }

  const handleSOChange = (event: any) => {
    props.setSalesOrgEvent(event);
    if (props.routesSelected.length<=0) {
      let value = event.target.value;
      const rts = props.data.routes.filter((elem: { deliveringPlant: any; }) => elem.deliveringPlant === value);
      sessionStorage.setItem("selectedDeliveryPlant",value);
      setState({deliveringPlant: value, route: "", routes: rts});
      props.onSelectionChange(value, '', rts);
    }else{
      props.setAlertClearRoute(true);
    }
  }

  const handleRouteChange = (event: any) => {
    props.setRouteEvent(event);
    if (props.routesSelected.length<=0) {
      let value = event.target.value;
      
      if(props.data.isRelaseDraftModified&&!props.data.isReleaseDraftSaved){
        setSaveDraftAlert({ title: "Save Release Draft", msg: "Your changes on Release Adjustments will be lost. Do you wish to proceed without saving?",actionType:SaveActionAlertType.ROUTE,actionData:{salesOffice:state.deliveringPlant,route: value, filteredRoutes: state.routes} });
      }else{
        setState({...state, route: value});
        sessionStorage.setItem("selectedRoute",value);
        props.onSelectionChange(state.deliveringPlant, value, state.routes);
      }
    }else{
      props.setAlertClearRoute(true);
      sessionStorage.setItem("selectedRoute",'');
    }
  }

  const handleDateChange = (newDate: any) => {
    if(newDate!==null){
      const date = new Date(newDate);
      if (Object.prototype.toString.call(date) === '[object Date]' && !isNaN(newDate)) {
        if (!isPastDate(newDate)) {
          if(props.data.isRelaseDraftModified&&!props.data.isReleaseDraftSaved){
            setSaveDraftAlert({ title: "Save Release Draft", msg: "Your changes on Release Adjustments will be lost. Do you wish to proceed without saving?",actionType:SaveActionAlertType.DATE,actionData:newDate });
          }else{
            setSelectedDate(date);
            setModifiedDate(date);
            props.onDateChange(date);
          }
        }else {
          setErrorMessage({
            title:"Unable to View Past Six Months.",
            message:"Please choose a date that is not more than six months in the past."
          });
        }
      }
    }else{
      setSelectedDate(new Date(modifiedDate));
    }
    
  }

  const plant = props.data.plants;
  // console.log("salesOffices",props.data,props)
  useEffect(()=>{
    if(defaultSalesOffice && state.routes.length < 1){
      const rts = props.data.routes.filter((elem: { deliveringPlant: any; }) => elem.deliveringPlant === defaultSalesOffice);
      setState({deliveringPlant: defaultSalesOffice, route: "", routes: rts});
    }
  },[props.data])

  useEffect(()=>{
    getAlertMessageData(salesOrg).then((v) => {
      
        for (let i=0;i<v.data?.length;i++){
        let currentDate = new Date();
        // let startDate = new Date(v.data[i].startDate);
        // let endDate = new Date(v.data[i].startDate);

        if((currentDate >= new Date(v.data[i].startDate)) && (currentDate <= new Date(v.data[i].endDate))){
        setAlertMessage(v.data[i].message);
        setOpen(true);
        }
        }
      });
  },[])

  useEffect(()=>{
    if (props.routesSelected.length<=0&&props.routeEvent!=="") {
      if (props.routeEvent.target.value!==state.route) {
       // sessionStorage.setItem("selectedRoute",props.routeEvent.target.value);
        handleRouteChange(props.routeEvent);
      }
    }
  },[props.routesSelected]);

  useEffect(()=>{
    if (props.routesSelected.length<=0&&props.salesOrgEvent!=="") {
      if (props.salesOrgEvent.target.value!==state.deliveringPlant) {
        handleSOChange(props.salesOrgEvent);
      }
    }
  },[props.routesSelected]);

  
  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  function subtractSixMonths(date:any) {
    date.setMonth(date.getMonth() - 6);
    // date.setDate(1)
    return date;
  }


  const renderWeekPickerDay = (
    date: Date,
    selectedDates: Array<Date | null>,
    pickersDayProps: PickersDayProps<Date>
  ) => {
    
  let days=new Date(date).toISOString().split('T')[0];

 let style=props.datePickerData.includes(days)?{ 
    styles:{ color: "#fff",backgroundColor:'#525352'},
    hoverStyles:{ backgroundColor: '#525352'}
   }
 :{}


    return (
      <PickersDay
        {...pickersDayProps}
        sx={{
           ...style.styles,
          '&:hover': style.hoverStyles,
        }}
      />
    );
  };

  const customTitle = (items: any)=>{
    const sortedValue = items.sort((a: any, b: any) => {
      const timestampA = new Date(a.timestamp).getTime();
      const timestampB = new Date(b.timestamp).getTime();
      return timestampB - timestampA;
    });
    return (
      <>
      <ul>
        {sortedValue.map((ele: any)=> <li>{`${ele.action} by- ${ele.user_name}, customers- ${ele?.confirmed_customers}, ${ele?.timestamp ? ele?.timestamp.split('T')[0]: ""} ${ele?.timestamp? ele?.timestamp.split('T')[1].slice(0, -5):""}`}</li>)}
      </ul>
      </>
    )
  }
  
  return (
    <Paper className={classes.cont}>
      <Snackbar
        open={open}
        style={{marginTop:'40px',width:'100%',textAlign:'center'}}
        anchorOrigin={{ horizontal:'center', vertical:'top'  }}
        autoHideDuration={6000}
      >
      <AlertSuccess onClose={handleClose} severity='error' sx={{ width: '99%',textAlign:'center', justifyContent:'center'}}>
          {alertMessage}
      </AlertSuccess>
      </Snackbar>
      <Grid className={classes.grid} container spacing={3}>
        <Grid item xs={4} md={4} lg={4} xl={4}>
        <TextField
        fullWidth
        color="secondary"
        label="Delivery Plant"
        value={state.deliveringPlant || ''}
        select
        onChange={handleSOChange}
        disabled={props.data.isLoading}
        >
        {plant.map((option: any) => (
         <MenuItem key={option.plant} value={option.plant}>
           {option.name}
         </MenuItem>
       ))}
      </TextField>

        </Grid>
          <Grid item xs={2} md={2} lg={2} xl={2}>
          <TextField
          fullWidth
          color="secondary"
          label="Route"
          value={state.route || ''}
          select
          onChange={handleRouteChange}
          disabled={props.data.isLoading}
          >
          {state.routes.map((option: any) => (
          <MenuItem key={option.route} value={option.route}>
            {option.route}
          </MenuItem>
        ))}
          </TextField>
          </Grid>
        <Grid item xs={3} md={3} lg={3} xl={3}>
          <LocalizationProvider  dateAdapter={AdapterDateFns}>
            <DatePicker
              minDate={subtractSixMonths(new Date())}
              value={selectedDate}
              onChange={handleDateChange}
              disabled={props.data.isLoading}
              renderInput={(props: any) => {
               return <TextField {...props} variant="outlined" label={formatDateLabel} fullWidth />
              }}
              renderDay={renderWeekPickerDay}
            />
          </LocalizationProvider >
        </Grid>
        <Grid item className={classes.save} xs={3} md={3} lg={3} xl={3}>
        <div style={{ display: 'flex'}}>
          <div  style={{ marginLeft:'150px' }}>
            <Typography>Planning Mode: {props.data.planMode}</Typography>
            {/* <Tooltip title='Confirmed Customers/ Overdue (60+ Days) / Scheduled Machines / Scheduled Stops / # Cases w/o Buffer / # Cases / Extras'><Typography>{props.data.confirmed} / {props.data.overdue} / {props.data.scheduled} / {props.data.banked} / {props.data.act_cases} / {props.data.cases} / {props.data.extras}</Typography></Tooltip> */}
            {props?.data?.confirmed && props.data.confirmed>0?<>
              <Tooltip title='Confirmed Stops / # Cases w/o Buffer / # Cases / Extras'><Typography>{props.data.confirmed} / {props.data.act_cases} / {props.data.cases} / {props.data.extras&&props.data.extras>0?props.data.extras:0}</Typography></Tooltip>
            </>:<>
            <Tooltip title='Overdue (60+ Days) / Scheduled Machines / Scheduled Stops / # Cases w/o Buffer / # Cases / Extras | PFU'><Typography style={{ whiteSpace: 'pre-wrap' }}>{props.data.overdue} / {props.data.scheduled} / {props.data.banked} / {props.data.act_cases} / {props.data.cases} / {props.data.extras} | {`    PFU=`+props.data?.total_eaches}</Typography></Tooltip>
            {isDisplayOnlyRole ?
            <><div style={{width: '140px', height: "2px", backgroundColor:"#0e0d0d", margin:"5px auto"}}></div>
            <Tooltip title='Suggested Overdue (60+ Days) / Suggested Scheduled Machines / Suggested Scheduled Stops / Suggested # Cases w/o Buffer / Suggested # Cases / Suggested Extras | PFU'><Typography style={{ whiteSpace: 'pre-wrap' }}>{props.data?.hsReview?.reviewOverdue} / {props.data?.hsReview?.reviewScheduled} / {props.data?.hsReview?.reviewBanked} / {props.data?.hsReview?.reviewActCases} / {props.data?.hsReview?.reviewCases} / {props.data?.hsReview?.reviewExtras} | {`    PFU=`+props.data?.hsReview?.reviewEaches}</Typography></Tooltip>
            </>
            :<></>
            }
            </>}
          </div>
          {props.data?.routeInfoTrack?.length ? <div style={{ marginLeft:'30px' }}>
            <Tooltip title={customTitle(props.data?.routeInfoTrack)}><InfoIcon></InfoIcon></Tooltip>
            </div> :<></>}
        </div>
        </Grid>
      </Grid>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={errorMessage !== undefined}
        onClose={()=>{setErrorMessage(undefined);}}
      >
        <DialogTitle>{errorMessage?.title}</DialogTitle>
        <DialogContent>  
          <Typography paragraph>{errorMessage?.message}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{setErrorMessage(undefined);}} color="primary">
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="dri-title"
        open={Object.keys(saveDraftAlert).length !== 0}
        onClose={() => {
          setSaveDraftAlert({});
        }}
      >
        <DialogContent>
          <Alert severity="error">
            <AlertTitle>{saveDraftAlert && saveDraftAlert.title ? saveDraftAlert.title : "Save Release Draft"}</AlertTitle>
            <Typography paragraph>{saveDraftAlert && saveDraftAlert.msg ? saveDraftAlert.msg : "Your changes on Release Adjustments will be lost. Do you wish to proceed without saving?"}</Typography>
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
              setSaveDraftAlert({});
            }} 
            color="primary">
            No
          </Button>
          <Button onClick={() => {
            if(saveDraftAlert.actionType ==SaveActionAlertType.DATE){
              setSelectedDate(saveDraftAlert.actionData);
              props.onDateChange(saveDraftAlert.actionData);
            }else{
              setState({...state, route: saveDraftAlert.actionData.route});
              props.onSelectionChange(saveDraftAlert.actionData.salesOffice, saveDraftAlert.actionData.route, saveDraftAlert.actionData.filteredRoutes);
            }
              setSaveDraftAlert({});
            }}  
            color="primary" autoFocus>
            Yes, proceed
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
}
